export const APROBATION_USE_DISTRIBUTION = 'io.web.aprobacion.use.distribucion';
export const MENU_COLLAPSE_GROUPS = 'io.web.ed.menu.colapsar.grupos';
